


























import { Vue } from "vue-property-decorator"
import type { url } from "@/@types/base"
import TsUpload from "@/components/upload.vue";

export default Vue.extend({
  name      : "CooperationUpload",
  components: { TsUpload },
  props     : {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
  },
  data() {
    return {
      host          : "https://data.taisam.cn",
      empty_url     : { path: "", url : "" } as url,
      stadium_ground: [
        { path: "", url : "" } as url
      ],
    }
  },
  methods: {
    init(data: any) {
        /* 附件4：场馆经营场地证明材料 */
        if (data.stadium_ground_urls && data.stadium_ground_urls.length > 0) {
        const urls = []
        for (const v of data.stadium_ground_urls) {
          if (v != "") {
            const p = v.replace(this.host, "")
            urls.push({ path: p, url: `${this.host}${p}` })
          }
        }
        urls.push(this.empty_url)
        this.stadium_ground = urls
      }
    },
    handleChange(path: string, index: number) {
      if (path == "") {
        const temp = this.$deep_copy(this.stadium_ground)
        this.stadium_ground = []
        for (const k in temp) {
          if (k != String(index)) {
            if (Object.prototype.hasOwnProperty.call(temp, k)) {
              this.stadium_ground.push(temp[k])
            }
          }
        }
      } else this.stadium_ground[index] = { path, url: this.host + path }
      this.add_upload(this.stadium_ground)
    },
    add_upload(urls: url[]) {
      let count = 0
      for (const v of urls) {
        if (v.path == "") count += 1
      }
      if (count == 0) {
        urls.push({ path: "", url: "" })
      }
    },
      /* 处理 URL */
    handleURLS(data: url[]):string {
      const urls = []
      for (const v of data) if (v.path != "") urls.push(v.path)
      return urls.join(",")
    },
    submit() {
      const params = { estimate_id: this.id, stadium_ground_urls: this.handleURLS(this.stadium_ground) }
      this.$emit("save", params)
    },
    check(): boolean {
      return this.stadium_ground.length > 1
    },
  }
})

